import { apiRequest } from "src/apis/instance";
import { emitLogout } from "src/break/bus";
import { getToken } from "src/utils";

const UserLogin = async (data) => {
    return apiRequest.post('auth/login', data).then((res) => {
        window.localStorage.setItem("auth", res.data);
        return res;
    }).catch((err) => {
        console.log(err);
        return err.response;
    })

};

const Logout = async () => {
    // Close the break hub before the token disappears, otherwise the connection stays up for the
    // moment it takes the reload below to happen.
    emitLogout();
    await UpdateLoginStatus().then(() => {
        window.localStorage.clear()
        window.localStorage.clear()
        window.location.reload();
    });

};

const config = () => {
    const token = getToken();
    const configObj = { headers: { Authorization: `Bearer ${token}` } };
    return configObj
}

const UpdateLoginStatus = async () => {
    return apiRequest.post('auth/UpdateLoginStatus', {}, config()).then((res) => {
        return res;
    }).catch(err => {
        console.log(err)
    })
};

const UserDetails = async () => {

    return apiRequest.get('auth/GetUserDetail', config()).then((res) => res).catch(err => console.log(err))
};

const getAgentsData = async () => {
    return apiRequest.get('auth/getAgentsData', config()).then((res) => {
        return res
    }).catch((err) => {
        console.log(err)
    });
};

const addAgentData = async (data) => {
    return apiRequest.post('auth/SaveAgentData', data, config()).then((res) => {
        return res
    }).catch((err) => {
        console.log(err)
    });
};

const deleteAgent = async (data) => {
    return apiRequest.post('auth/updateUserStatus', data, config()).then((res) => {
        return res
    }).catch((err) => {
        console.log(err);
    });
};

//get system users
const systemUser = async () => {
    return apiRequest.post('Auth/GetSystemUsers', null, config()).then(res => res).catch(err => err)
}

const getHolidayAgents = async () => {
    return apiRequest.post('auth/GetHolidayAgents', null, config()).then(res => res).catch(err => console.log(err));
};

const getFilteredAgents = async () => {
    return apiRequest.post('auth/GetFilteredAgents', null, config()).then(res => res).catch(err => console.log(err));
};

const getHolidayVisaAgents = async () => {
    return apiRequest.post('auth/GetHolidayVisaAgents', null, config()).then(res => res).catch(err => console.log(err));
};

export { UserLogin, Logout, UserDetails, getAgentsData, addAgentData, deleteAgent, systemUser, getHolidayAgents, getFilteredAgents,getHolidayVisaAgents };